import {BiReset} from "react-icons/bi";
import {Accordion, Button, ColorPicker} from "../../../../components";
import {useCurrentUser} from "../../../../contexts/UserContext";
import {useViewerStore} from "../../../../store/store";
import {Alert} from "antd";
import {wallData} from "../../../../Constants";

const ObstructionStyle: React.FC = () => {
    const {user, hasCapability} = useCurrentUser();

    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const obstructionSelectedColor = useViewerStore(state => state.obstructionSelectedColor);

    const obstructionTextureChangeHandler = (e: React.MouseEvent<HTMLImageElement>) => {
        document.querySelectorAll('.pattern__img').forEach((item) => {
            item.classList.remove('active');
        });

        const buttonEl = e.currentTarget.parentElement;
        const listItemEl = buttonEl?.parentElement;

        if (buttonEl instanceof HTMLElement) {
            buttonEl.classList.add('active');
        }

        if (listItemEl instanceof HTMLElement) {
            const title = listItemEl.title || '';
            const src = e.currentTarget.src;

            sceneViewer.setMeshTexture(
                sceneViewer.obstMeshArr,
                src,
                'obst',
                title
            );
        }
    };

    const resetObstPatternHandler = () => sceneViewer.resetObstToDefault();


    const handleObstructionColorChange = (color: string) => {
        useViewerStore.setState({obstructionSelectedColor: color});
        sceneViewer.setMeshMaterialColor(sceneViewer.obstMeshArr, color);
    }

    return (
        <>
            {user ?
                <div className="tab__inner">
                    {
                        hasCapability('Toggle_Siding') && (
                            <>
                                <div className="tab__title">
                                    <span className="tab__title--text">Obstruction Style</span>
                                    <div className="tab__title--btns">
                                        <Button
                                            onClick={resetObstPatternHandler}
                                            variant='btn-clear'
                                            size='btn-resize'
                                            title={'Reset to Default'}>
                                            <BiReset/>
                                        </Button>
                                    </div>
                                </div>

                                <>
                                    <div className="tab__column">
                                        <Accordion title='Select Obstruction Style' active={true}>

                                            <ul className='pattern'>
                                                {wallData.map((item, index) => (
                                                    <li className='pattern__item' key={index}>
                                                        <Button
                                                            variant='btn-clear'
                                                            size='btn-resize'
                                                            className='pattern__img'
                                                            title={item.alt}
                                                        >
                                                            <img onClick={obstructionTextureChangeHandler} src={item.img}
                                                                 alt={item.alt}/>
                                                        </Button>
                                                    </li>
                                                ))}
                                            </ul>

                                        </Accordion>
                                    </div>
                                </>

                                <>
                                    <div className="tab__column">
                                        <div className="tab__flex justify-between mb-1">
                                            <span className="tab__column--subtitle">Obstruction Color</span>
                                            <ColorPicker
                                                currentColor={obstructionSelectedColor}
                                                changeHandler={handleObstructionColorChange}/>
                                        </div>
                                        <Alert 
                                            style={{color: 'black', fontSize: '12px'}}
                                            message="Dark mode extensions may cause unexpected behavior with the color picker. Please disable any related extensions and use oneDRAW's built-in dark mode to proceed."
                                            type='warning'
                                            showIcon
                                        />
                                        <span className='tab__spacer'></span>
                                    </div>
                                </>
                            </>
                        )
                    }
                </div>
                : ""
            }
        </>
    );
};

export default ObstructionStyle;
